import React from "react"
import BoldedText from "src/shared/components/data-display/bolded-text/BoldedText"
import { ModalConfirm } from "src/shared/components/layout"
import Icon from "src/shared/icons"

const ConfirmCambioAlmacen = ({
    onConfirm,
    isOpen,
}: {
    onConfirm: ({ confirmed }: { confirmed: boolean }) => void
    isOpen: boolean
}) => {
    return (
        <ModalConfirm
            isOpen={isOpen}
            iconTheme="danger"
            icon={<Icon name="Warning" color="var(--pink-ocupado)" />}
            title="¿Deseas editar la categoría de suministro?"
            description={
                <BoldedText>
                    Al editar las categorías de suministro de Room Service, **los productos y recetas dejarán de
                    mostrarse en la categoría anterior.** Para que aparezcan en la nueva categoría, **es necesario
                    transferir las unidades del producto al nuevo almacén.**
                </BoldedText>
            }
            onCloseDialog={onConfirm}
        />
    )
}

export default ConfirmCambioAlmacen
